module.exports = __webpack_public_path__ + "img/6D6D6D_3E3E3E_C0C0C0_949494-256px.262b94f6.png";